<template src="./plotsPage.html"></template>

<script>
import pipe from '../../../../../components/pipe/pipe.vue';
import reportMixin from '../../../../../js/reportMixin';

export default {
    name: 'plots-page',
    props: [
        'currentSelectedTab', 
        'observations', 
        'headerInputs', 
        'sessionFields', 
        'headerOptionsAndValues', 
        'reportTitle'
    ],
    components: {'pipe': pipe,},
    mixins: [reportMixin],
    data() {
        return {
            ready: false,
            plotsObservations: [],
        }
    },
    computed: {
        imagePath() {
            return window.path;
        },
        session() {
            return this.$store.state.SessionsModule.Session;
        },
        reportSettings() {
            return this.$store.state.ReportsModule.ReportSettings
        },
        sortedObservations() {
            if (this.reportSettings.OtherActionSettings.chkSortByTime) {
                return this.plotsObservations.sort((a,b) => a.VideoPosition - b.VideoPosition);
            }
            else if (this.reportSettings.OtherActionSettings.chkMirrorPlotReport) {
                return this.plotsObservations.reverse();
            } 
            return this.plotsObservations.sort((a,b) => a.Distance - b.Distance);
        },
        upstreamManhole() {
            this.sessionFields.forEach((f) => {
                console.log(f.LabelText)
            })
            let umh = this.sessionFields.find((field) => field.LabelText === 'Upstream MH' || field.LabelText === 'Start ID' || field.LabelText === 'Upstream Manhole' || field.LabelText === 'Manhole Number' || field.LabelText === 'Upstream MH Number');


            let umhText = '';
            if (this.reportSettings.OtherActionSettings.chkMirrorPlotReport) {
                if (this.reportSettings.IDTextSettings.txtBottomIDPlotText.length > 0) {
                    umhText = this.reportSettings.IDTextSettings.txtBottomIDPlotText + ' '
                }
            }
            else if (this.reportSettings.IDTextSettings.txtTopIDPlotText.length > 0) {
                umhText = this.reportSettings.IDTextSettings.txtTopIDPlotText + ' '
            }

            if (umh) {
                umhText += umh.Value;
            }

            return  umhText;
        },
        downstreamManhole() {
            let dmh = this.sessionFields.find((field) => {
                 return (field.LabelText === 'Downstream MH' || field.LabelText === 'End ID' || field.LabelText === 'Downstream Manhole' || field.LabelText === 'Downstream MH Number');
            });

            let dmhText = '';
            if (this.reportSettings.OtherActionSettings.chkMirrorPlotReport) {
                dmhText = this.reportSettings.IDTextSettings.txtTopIDPlotText + ' '
            }
            else if (this.reportSettings.IDTextSettings.txtBottomIDPlotText.length > 0) {
                   dmhText = this.reportSettings.IDTextSettings.txtBottomIDPlotText + ' '
            }

            if (dmh) {
                dmhText += dmh.Value;
            }

            return  dmhText;
        },
    },
    methods: {
        checkIfPageReady() {
            return new Promise((resolve, reject) => {
                const start = Date.now();

                const check = () => {
                    if (this.$refs.pipeComponent && this.$refs.pipeComponent.ready) {
                        resolve();
                    } else if (Date.now() - start > 10000) {
                        resolve();
                    } else {
                        setTimeout(check, 50);
                    }
                };

                check();
            })
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.checkIfPageReady()
                .then(() => {
                    this.ready = true;
                });
        });
    },
    created() {
        this.plotsObservations = DMUtils.copy(this.observations);
    }
}

</script>
